import { Color } from "@starrez/starryui";
import styled from "styled-components";

export interface IParticipantRadioDivProps {
    HasError?: boolean;
    HasParticipants?: boolean;
}

export const ParticipantRadioDiv = styled.div<IParticipantRadioDivProps>`

    legend > div {
        font-weight: 700;
        color: #12374E !important;
        font-size: 14px!important;
    }

    ${(props: IParticipantRadioDivProps) => props.HasError && `
        div[role="radiogroup"] > div:last-child > p {
            color: ${Color.Red.R60} !important;
        }
    `}

    transition: margin-bottom 0.2s;
    margin-bottom: ${(props: IParticipantRadioDivProps) => props.HasError ? (props.HasParticipants ? "-22px" : "0") : (props.HasParticipants ? "-45px" : "-22px")};
`;
